import { Duration } from "luxon";

export interface RemoveOrUnassignedLocationsRequest {
    locationId: string | undefined;
    planId: string | undefined;
    //IsCalculateETA: boolean | undefined;
    selectedLocationId : string ;
    connectionId : string | undefined;
    productId : string | undefined;
    activityName : string | undefined;
    serviceFromTime : Duration | undefined;
    serviceToTime : Duration | undefined;
    selectedJobId : string | undefined;
    currentJobRemoveAllDuplicate : boolean | undefined;
  }
  